import { Radio, RadioGroup, FormControlLabel, Typography } from "@mui/material";
import Loading from "../../../../../../load/loading";
import LoadingSkteleton from "../../../../../../load/loadingSkeleton";

// const RESTRICOES = [
//     { value: "a", label: "Nenhuma" },
//     { 'tipoEstabelecimento': 'Farmácia', 'descricao': "Psicotrópicos, Estupefacientes e outros medicamentos sujeitos à legislação especial." },
//     { value: "c", label: "Medicamento, material gastável e outros produtos de saude não descrito no paragrafo terçeiro." },
//     { value: "d", label: "Medicamento, material gastável, equipamentos medicos, material hospitalar e outros produtos de saude não descrito no paragrafo terçeiro." },
//     { value: "e", label: "Equipamento médico, meios de diagnóstico e outros produtos de saúde não descritos no parágrafo terceiro." },
//     { value: "f", label: "Medicamento, material gastável e outros produtos de saúde não descritos no parágrafo terceiro." },
//     { value: "g", label: "Medicamento convencionais, equipamentos médicos, meios de diagnóstico e outros produtos de saúde não descritos no parágrafo terceiro." },
// ];

export default function RestricaoOptions({ value, onChange, options }) {
    return (
        <>
            <RadioGroup name="restricaoAutorizacao" value={value} onChange={onChange}>
                {options.map((item, index) => (
                    <Typography key={item.value} m={1}>
                        <FormControlLabel
                            value={item.descricao}
                            control={<Radio />}
                            label={`${index + 1} - ${item.descricao}`}
                        />
                    </Typography>
                ))}
            </RadioGroup>

            {options.length < 1 && <LoadingSkteleton />}
        </>
    );
}
